export function createIconUrl(point: Availability, selected = false) {
  let provider = point.provider.toLowerCase()
  if (provider === 'ice') provider = 'callabike'
  const baseUrl = `/map/${provider}`
  let iconPath = '/station-bike'

  if (isPedelecStation(point)) {
    iconPath = `/station-pedelec`
  }

  if (isCargoPedelecStation(point)) {
    iconPath = `/station-pedelec-cargo`
  }

  if (point.bikes.length === 0) {
    iconPath = `/station-empty`
  }

  if (point.stationType === 'FREE_FLOATING') {
    iconPath = `/bike`
    if (isPedelecStation(point) || isCargoPedelecStation(point)) {
      iconPath = `/pedelec`
    }
  }
  return `${baseUrl}${iconPath}${selected ? '-selected' : ''}.svg`
}

const isPedelecStation = (point: Availability) =>
  point.bikeTypes.includes('PEDELEC') ||
  point.bikes.some((bike) => bike.type === 'PEDELEC')

const isCargoPedelecStation = (point: Availability) =>
  point.bikeTypes.includes('CARGOPEDELEC') ||
  point.bikes.some((bike) => bike.type === 'CARGOPEDELEC')
